// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_30-1";
export var movingGradient = "_30-4";
export var movingGradientBlock = "_30-2";
export var skeleton = "_30-0";
export var skeletonText = "_30-3";